export function dedupe_deep<T>(array: T[]): T[] {
  if (array.length <= 1) return array;
  return Array.from(new Set(array.map((item) => JSON.stringify(item)))).map(
    (item) => JSON.parse(item),
  );
}

export function dedupe_simple<T extends number | string>(array: T[]): T[] {
  if (array.length <= 1) return array;
  const found: Set<T> = new Set();
  return array.filter((item) => {
    if (found.has(item)) return false;
    found.add(item);
    return true;
  });
}

export function dedupe_by<T, K extends number | string>(
  array: T[],
  check: (item: T) => K,
): T[] {
  if (array.length <= 1) return array;
  const keep: Set<K> = new Set();
  return array.filter((item) => {
    const key = check(item);
    if (keep.has(key)) return false;
    keep.add(key);
    return true;
  });
}

export function objectKeys<K extends string, T>(object: Record<K, T>): K[] {
  // eslint-disable-next-line no-restricted-properties
  return Object.keys(object) as K[];
}
export function objectKeysNumber<T>(object: Record<number, T>): number[] {
  return objectKeys(object).map((key) => +key);
}
export function objectEntries<K extends string, T>(
  object: Record<K, T>,
): [K, T][] {
  return objectKeys(object).map((key) => [key, object[key]]);
}
export function objectEntriesNumber<T>(
  object: Record<number, T>,
): [number, T][] {
  return objectKeysNumber(object).map((key) => [key, object[key]]);
}

export function objectFromEntries<K extends PropertyKey, T>(
  entries: [K, T][],
): Record<K, T> {
  // eslint-disable-next-line no-restricted-properties
  return Object.fromEntries(entries) as Record<K, T>;
}

export function notEmpty<T>(value: T | undefined | null): value is T {
  // if (value instanceof Array) return value.length > 0; //maybe later. Might not match function usages
  return value !== undefined && value !== null;
}
